import cs from 'classnames';
import { useCallback, useRef, useState } from 'react';
import { Button, Col, DownLineIcon, InViewport, Row } from 'ui';

const ContinueReading = () => {
  const reference = useRef<HTMLDivElement>(null);
  const [isHidden, setIsHidden] = useState(false);

  const scrollToViewport = useCallback(() => {
    reference.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <>
      <InViewport
        onEnter={() => {
          setIsHidden(true);
        }}
        reference={reference}
      />
      <Row align="middle" className={cs('continue-reading', { 'continue-reading__hidden': isHidden })} justify="center">
        <Col>
          <Button icon={<DownLineIcon />} onClick={scrollToViewport} size="large" type="link-primary">
            Continue reading
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ContinueReading;
